// extracted by mini-css-extract-plugin
export default {"card_heading":"upcoming-events_card_heading__6o2tx","topBar":"upcoming-events_topBar__PSVLG","tableWrapper":"upcoming-events_tableWrapper__3ATDO"};